import type { IFilter } from '@models/Filter'

import { apiClient } from '../../../gateways/api'
import type { ContractinstellingenBijlagenSearch } from '../types/ContractinstellingenBijlagenSearch'
import type { ContractinstellingenSearchFilters } from '../types/ContractinstellingenSearch'

export const fetchTemplates = async (
  filters: ContractinstellingenSearchFilters,
) => {
  const { data } = await apiClient<ContractinstellingenBijlagenSearch['data']>({
    url: '/rest/template/search',
    method: 'POST',
    data: {
      filters: createFilters(filters),
      skip: 0,
      limit: 1000,
    },
  })

  return data
}

export const initialState: ContractinstellingenBijlagenSearch = {
  data: { activiteitTemplates: [], bijlageTemplates: [] },
  query: {
    filters: {
      templateSet: null,
    },
  },
}

export const createFilters = ({
  verantwoordelijke,
}: ContractinstellingenSearchFilters) => {
  const filters: IFilter[] = [
    { name: 'projectType', value: 'Hoofdleiding', operator: 'eq' },
  ]

  if (verantwoordelijke)
    filters.push({
      name: 'verantwoordelijke',
      value: verantwoordelijke.label,
      operator: 'eq',
    })
  return filters
}
